<template>
  <el-dialog
    title="Cập nhật trạng thái thanh toán"
    :visible="visible"
    class="responsive invoice-payment-status-modal"
    width="480px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="form-group mb-4">
      <label>Mã hóa đơn</label>
      <el-input
        :value="invoice ? invoice.invoice_code : ''"
        class="invoice-code-input w-100"
        disabled
      >
        <i slot="prefix" class="el-input__icon fas fa-file-invoice"></i>
      </el-input>
    </div>

    <div class="form-group mb-4">
      <label>Mã thanh toán</label>
      <el-input
        v-model="paymentCode"
        placeholder="Nhập mã thanh toán"
        class="w-100"
        clearable
      />
    </div>

    <div class="form-group mb-0">
      <label>Trạng thái thanh toán <span class="text-danger">*</span></label>
      <el-select v-model="paymentStatus" placeholder="Chọn trạng thái" class="w-100">
        <el-option
          v-for="item in paymentStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>

    <div v-if="submitError" class="alert alert-custom alert-light-danger mt-4 mb-0 py-3">
      <div class="alert-text">{{ submitError }}</div>
    </div>

    <footer class="d-flex justify-content-end pt-5">
      <button
        type="button"
        class="btn btn-secondary font-weight-bold mr-2"
        :disabled="submitting"
        @click="handleClose"
      >
        Đóng
      </button>
      <button
        type="button"
        class="btn btn-primary font-weight-bold"
        :disabled="submitting"
        @click="handleSubmit"
      >
        <i v-if="submitting" class="fas fa-spinner fa-spin mr-1"></i>
        {{ submitting ? "Đang cập nhật..." : "Cập nhật" }}
      </button>
    </footer>
  </el-dialog>
</template>

<script>
export default {
  name: "InvoicePaymentStatusModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Object,
      default: null,
    },
    submitHandler: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      paymentStatus: 0,
      paymentCode: "",
      submitting: false,
      submitError: "",
      paymentStatusOptions: [
        { value: 0, label: "Chưa thanh toán" },
        { value: 1, label: "Thanh toán 50%" },
        { value: 2, label: "Đã thanh toán" },
      ],
    };
  },
  watch: {
    visible(value) {
      if (value) this.syncPaymentStatus();
    },
    invoice() {
      if (this.visible) this.syncPaymentStatus();
    },
  },
  methods: {
    syncPaymentStatus() {
      this.paymentStatus = Number(this.invoice?.payment_status) || 0;
      this.paymentCode = this.invoice?.payment_code || "";
      this.submitError = "";
      this.submitting = false;
    },
    async handleSubmit() {
      if (!this.invoice || this.submitting) return;
      this.submitting = true;
      this.submitError = "";
      const payload = {
        id: this.invoice.id,
        payment_status: this.paymentStatus,
        payment_code: String(this.paymentCode || "").trim() || null,
      };

      try {
        if (this.submitHandler) await this.submitHandler(payload);
        this.$emit("submit", payload);
        this.handleClose();
      } catch (error) {
        this.submitError = error?.message || "Không thể cập nhật trạng thái thanh toán";
      } finally {
        this.submitting = false;
      }
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.invoice-payment-status-modal >>> .invoice-code-input .el-input__inner {
  color: #3f4254;
  font-weight: 600;
  background-color: #f5f7fa;
}
</style>
